<app-dialog-header
	variant="info"
	(closeClick)="close()"
/>
<mat-dialog-content [style.minHeight.px]="200">
	<h3>
		{{ (utils.isNullOrUndefined(data?.successMsg) ? "dialog.success.message" : data.successMsg) | translate }}
	</h3>
	<br />
	@if (!utils.isNullOrUndefined(data?.startDate)) {
		<h3>{{ "auction.message.startDate" | translate }}: {{ data.startDate | ckDate: false }}</h3>
		<h3>{{ "auction.message.endDate" | translate }}: {{ data.endDate | ckDate: false }}</h3>
	}
	<br />

	<div class="d-flex text-center justify-content-center gap-3">
		<a
			(click)="close()"
			class="btn btn-outline text-uppercase"
		>
			<i
				class="fa fa-times"
				style="padding-right: 8px"
			></i>
			{{ "confirmDialog.dialog.cancel" | translate }}
		</a>
		<a
			(click)="ok()"
			class="btn btn-blue text-uppercase"
		>
			<i
				class="fa fa-check-circle"
				style="padding-right: 8px"
			></i>
			{{ "confirmDialog.dialog.ok" | translate }}
		</a>
	</div>
</mat-dialog-content>